module.exports = __webpack_public_path__ + "static/presidents-0eaa3c69db771107eb9f28f4ecf6a319.jpg";